import { render, staticRenderFns } from "./RowClickButton.vue?vue&type=template&id=55cd2722"
import script from "./RowClickButton.vue?vue&type=script&lang=js"
export * from "./RowClickButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports